<template>
  <portlet
          :icon="'fad fa-users'"
          :title="'Rechten aanmaken'"
          :actionsBlock="true"
          :footer="true"
  >
    <template slot="actionsBlock">
      <router-link tag="button" :to="{name:'roles'}" class="btn btn-secondary">
        <i class="fas fa-long-arrow-left mr-2"></i>
        Terug
      </router-link>
    </template>

    <template slot="portletBody">
      <form action>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="role-name">Naam</label>
            <input
                    v-validate="'required'"
                    name="name"
                    id="role-name"
                    type="text"
                    class="form-control"
                    v-model="role.name"
            />
            <span v-if="errors.first('name')" class="small text-danger">Dit veld is verplicht</span>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
              <label :for="role.name+'-department'">Vestiging</label>
              <select v-model="role.department" class="form-control">
                  <option disabled value="">Selecteer..</option>
                  <option v-for="dep in departmentOptions" :value="dep" :key="dep">
                      {{dep}}
                  </option>
              </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
            <vue-multi-select
              ref="multiSelect"
              v-model="role.rights"
              search
              historyButton
              :options="options"
              :filters="filters"
              :btnLabel="btnLabel"
              :selectOptions="selectOptions">
              <template v-slot:option="{option}">
                <input type="checkbox" :checked="option.selected"/>
                <span>{{option.name}}</span>
              </template>
            </vue-multi-select>
          </div>
        </div>
      </form>
    </template>
    <div slot="portletFooter" class="col text-right">
      <button @click="addRole" type="submit" class="btn btn-primary">
        <i class="fal fa-save mr-2"></i> Opslaan
      </button>
    </div>
  </portlet>
</template>

<script>
  import { RIGHTS } from './rights.js';
  import vueMultiSelect from 'vue-multi-select';
  import 'vue-multi-select/dist/lib/vue-multi-select.css';
  import { DEPARTMENTS } from '../../constants.js';
  
  let sections = {}
  Object.keys(RIGHTS).forEach(r => {
    const entity = r.split('_')[0];
    if(sections[entity]) {
      sections[entity].list.push({name: r})
    } else {
      sections[entity] = {
        name: entity,
        list: [
          { name: r },
        ],
      }
    }
  })

  const options = Object.values(sections);

  export default {
    data() {
      return {
        note: 'Test',
        disableNavigation: false,
        customerCopy: null,
        role: {
          name: '',
          rights: [],
          department: '',
        },
        btnLabel: values => `Rechten geselecteerd (${values.length})`,
        selectOptions: options,
        departmentOptions: DEPARTMENTS,
        filters: [{
          nameAll: 'Selecteer alles',
          nameNotAll: 'Deselecteer alles',
          func() {
            return true;
          },
        },],
        options: {
          multi: true,
          groups: true,
        },
      };
    },
    methods: {
      addRole() {
        this.$validator.validate().then(result => {
          if(result) {
            this.disableNavigation = false;

            this.$store.dispatch('roles/set', this.role).then(() => {
              this.$router.push('/roles');

              this.$toasted.global.successRequest({
                message: 'Rol aangemaakt'
              });

              this.role = {};
            }).catch(error => {
              this.$toasted.global.failedRequest();
            });
          } else {
            this.$toasted.global.failedFormRequest();
          }
        });
      }
    },
    watch: {
      role: {
        handler: function (val, oldV) {
          if(JSON.stringify(val) !== JSON.stringify(this.roleCopy)) {
            this.disableNavigation = true;
          }
        },
        deep: true
      },
    },
    components: {
      vueMultiSelect,
    },
  };
</script>
